import { useContext } from 'react';
import { ComponentContext } from '../../store/component/context';

export const useComponentSettings = () => useContext(ComponentContext);
